import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
var _excluded = ["children"],
  _excluded2 = ["children"];
/** @jsxRuntime classic */
/** @jsx jsx */
/* eslint-env browser */
/* eslint-disable no-nested-ternary */
import * as React from 'react';
import { jsx } from '@emotion/react';
import { components as defaultComponents } from 'react-select';
import { Spinner, Svg, Tag, TagList } from '@gandi/ui';
import { colors, fontSize, form, breakpoints, spacings, circles, icons } from './ui';
var theme = function theme(provided) {
  return _objectSpread(_objectSpread({}, provided), {}, {
    borderRadius: 6,
    spacing: _objectSpread(_objectSpread({}, provided.spacing), {}, {
      menuGutter: 0
    }),
    colors: _objectSpread(_objectSpread({}, provided.colors), {}, {
      primary: colors.blue,
      primary25: colors.greyLighter,
      danger: colors.danger,
      neutral5: colors.greyLighter,
      neutral10: colors.greyLight,
      neutral20: colors.grey,
      neutral30: colors.greyDark
    })
  });
};
var widgetHeight = function widgetHeight(variant) {
  return {
    minHeight: variant === 'small' ? form.widgetHeightSmall : form.widgetHeight
  };
};
var showSearchIcon = function showSearchIcon(props) {
  return props.selectProps.isSearchable && props.selectProps.menuIsOpen && !(props.selectProps.isMulti && props.selectProps.value);
};
var showCursor = function showCursor(props) {
  return props.selectProps.isSearchable && props.selectProps.menuIsOpen;
};
var styles = {
  container: function container(provided, state) {
    return _objectSpread(_objectSpread({}, provided), state.selectProps.style);
  },
  control: function control(provided, state) {
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, provided), widgetHeight(state.selectProps.uiVariant)), {}, {
      overflow: 'hidden',
      // Prevent borderRadius overflows.
      boxShadow: false,
      borderBottomLeftRadius: state.selectProps.menuIsOpen ? 0 : provided.borderRadius,
      borderBottomRightRadius: state.selectProps.menuIsOpen ? 0 : provided.borderRadius
    }, state.selectProps.isReadonly && !state.isFocused && {
      borderStyle: 'dashed'
    }), state.selectProps.isReadonly && {
      backgroundColor: colors.greyLighter
    }), {}, {
      '&, &:hover': {
        borderTopColor: state.isFocused ? colors.green : colors.grey,
        borderRightColor: state.isFocused ? colors.green : colors.grey,
        borderBottomColor: state.selectProps.menuIsOpen ? colors.grey : state.isFocused ? colors.green : colors.grey,
        borderLeftColor: state.isFocused ? colors.green : colors.grey
      }
    });
  },
  input: function input(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      margin: false,
      paddingTop: false,
      paddingBottom: false,
      '& input': {
        height: 'auto'
      },
      '& input:focus': {
        boxShadow: 'none'
      }
    });
  },
  menu: function menu(provided, state) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      borderStyle: 'solid',
      borderColor: colors.green,
      borderLeftWidth: 1,
      borderTopWidth: 0,
      borderRightWidth: 1,
      borderBottomWidth: 1,
      borderRadius: false,
      borderBottomLeftRadius: state.theme.borderRadius,
      borderBottomRightRadius: state.theme.borderRadius,
      boxShadow: false,
      overflow: 'hidden',
      // Prevent borderRadius overflows.
      zIndex: 5 // codemirror lines are a stacking context at 4.
    });
  },

  menuList: function menuList(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      paddingTop: false,
      paddingBottom: false,
      backgroundColor: 'white',
      scrollbarWidth: 'thin',
      scrollbarColor: "".concat(colors.greyLight, " white"),
      transition: 'scrollbar-color 0.2s',
      '&:hover': {
        scrollbarColor: "".concat(colors.green, " white")
      }
    });
  },
  indicatorsContainer: function indicatorsContainer() {
    return {
      flexShrink: 0,
      display: 'flex',
      alignSelf: 'stretch',
      alignItems: 'center'
    };
  },
  indicatorSeparator: function indicatorSeparator() {
    return {};
  },
  dropdownIndicator: function dropdownIndicator() {
    return {
      display: 'contents',
      // Vertical visual adjustment
      svg: _defineProperty({
        width: icons.size40,
        height: icons.size40,
        marginRight: spacings.mobile.small
      }, "@media (min-width: ".concat(breakpoints.small, ")"), {
        marginRight: spacings.small
      })
    };
  },
  clearIndicator: function clearIndicator() {
    return {
      flexShrink: 0,
      width: circles.size60,
      height: circles.size60,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: spacings.xsmall,
      borderRadius: '50%',
      transition: 'background-color 0.2s',
      svg: {
        width: icons.size30,
        height: icons.size30
      },
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: colors.greyLight
      }
    };
  },
  loadingIndicator: function loadingIndicator() {
    return {
      marginRight: '30px'
    };
  },
  valueContainer: function valueContainer(provided, state) {
    return _objectSpread(_objectSpread({}, provided), {}, _defineProperty({
      padding: false,
      paddingTop: spacings.xxsmall,
      paddingRight: spacings.xsmall,
      paddingBottom: spacings.xxsmall,
      // Visually align the magnifying icon with options.
      paddingLeft: showSearchIcon(state) ? false : spacings.mobile.small
    }, "@media (min-width: ".concat(breakpoints.small, ")"), {
      paddingLeft: showSearchIcon(state) ? false : spacings.small
    }), state.selectProps.isMulti && {
      gap: spacings.xxsmall
    });
  },
  singleValue: function singleValue(provided, state) {
    return _objectSpread(_objectSpread(_objectSpread({}, provided), {}, {
      position: false,
      top: false,
      marginLeft: false,
      marginRight: false,
      transform: false
    }, state.selectProps.isDisabled && {
      color: 'hsl(231, 72%, 11%, 0.7)'
    }), state.selectProps.isReadonly && {
      color: 'hsl(231, 72%, 11%)'
    });
  },
  option: function option(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, _defineProperty({
      padding: false,
      paddingTop: spacings.xsmall,
      paddingRight: spacings.mobile.small,
      paddingBottom: spacings.xsmall,
      paddingLeft: spacings.mobile.small
    }, "@media (min-width: ".concat(breakpoints.small, ")"), {
      paddingRight: spacings.small,
      paddingLeft: spacings.small
    }));
  },
  group: function group() {
    return {};
  },
  groupHeading: function groupHeading() {
    return _defineProperty({
      paddingTop: spacings.xsmall,
      paddingRight: spacings.mobile.small,
      paddingBottom: spacings.xsmall,
      paddingLeft: spacings.mobile.small,
      textTransform: 'uppercase',
      color: colors.textLight,
      fontSize: fontSize.small
    }, "@media (min-width: ".concat(breakpoints.small, ")"), {
      paddingRight: spacings.small,
      paddingLeft: spacings.small
    });
  },
  placeholder: function placeholder(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      marginRight: false,
      marginLeft: false,
      position: false,
      top: false,
      transform: false,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    });
  },
  noOptionsMessage: function noOptionsMessage() {
    var _ref2;
    return _ref2 = {
      paddingTop: spacings.xsmall,
      paddingRight: spacings.mobile.small,
      paddingBottom: spacings.xsmall,
      paddingLeft: spacings.mobile.small
    }, _defineProperty(_ref2, "@media (min-width: ".concat(breakpoints.small, ")"), {
      paddingRight: spacings.small,
      paddingLeft: spacings.small
    }), _defineProperty(_ref2, "backgroundColor", 'white'), _defineProperty(_ref2, "color", colors.textLight), _ref2;
  },
  loadingMessage: function loadingMessage() {
    var _ref3;
    return _ref3 = {
      paddingTop: spacings.xsmall,
      paddingRight: spacings.mobile.small,
      paddingBottom: spacings.xsmall,
      paddingLeft: spacings.mobile.small
    }, _defineProperty(_ref3, "@media (min-width: ".concat(breakpoints.small, ")"), {
      paddingRight: spacings.small,
      paddingLeft: spacings.small
    }), _defineProperty(_ref3, "backgroundColor", 'white'), _defineProperty(_ref3, "color", colors.textLight), _ref3;
  }
};
function DropdownIndicator(props) {
  var innerRef = props.innerRef,
    innerProps = props.innerProps,
    _props$selectProps = props.selectProps,
    menuIsOpen = _props$selectProps.menuIsOpen,
    isDisabled = _props$selectProps.isDisabled,
    isReadonly = _props$selectProps.isReadonly,
    getStyles = props.getStyles;
  if (isDisabled || isReadonly) return null;
  return jsx("div", _extends({
    ref: innerRef,
    css: getStyles('dropdownIndicator', props)
  }, innerProps), jsx(Svg, {
    name: menuIsOpen ? 'miniChevronTop' : 'miniChevronBottom',
    theme: "green"
  }));
}
function ClearIndicator(props) {
  var innerRef = props.innerRef,
    innerProps = props.innerProps,
    _props$selectProps2 = props.selectProps,
    isDisabled = _props$selectProps2.isDisabled,
    isReadonly = _props$selectProps2.isReadonly,
    getStyles = props.getStyles;
  if (isDisabled || isReadonly) return null;
  return jsx("div", _extends({
    ref: innerRef,
    css: getStyles('clearIndicator', props)
  }, innerProps), jsx(Svg, {
    name: "cross",
    theme: "grey-dark"
  }));
}
function IndicatorSeparator() {
  return null;
}
function LoadingIndicator(props) {
  var innerRef = props.innerRef,
    getStyles = props.getStyles;
  return jsx(Spinner, {
    name: "dots",
    refCallback: innerRef,
    css: getStyles('loadingIndicator', props)
  });
}
function MultiValue(props) {
  var children = props.children,
    removeProps = props.removeProps,
    _props$selectProps3 = props.selectProps,
    isDisabled = _props$selectProps3.isDisabled,
    isReadonly = _props$selectProps3.isReadonly;
  return jsx(Tag, {
    closeButtonProps: removeProps,
    disabled: isDisabled,
    readOnly: isReadonly,
    dismissible: true
  }, children);
}
function Control(props) {
  var selectProps = props.selectProps;
  var children = props.children,
    extraProps = _objectWithoutProperties(props, _excluded);
  return jsx(defaultComponents.Control, extraProps, showSearchIcon(props) && jsx(Svg, {
    name: "magnifying",
    theme: "green",
    css: _defineProperty({
      width: selectProps.uiVariant === 'small' ? icons.size40 : icons.size50,
      height: selectProps.uiVariant === 'small' ? icons.size40 : icons.size50,
      marginRight: spacings.xsmall,
      marginLeft: spacings.mobile.small
    }, "@media (min-width: ".concat(breakpoints.small, ")"), {
      marginLeft: spacings.small
    })
  }), children);
}
function Input(props) {
  return jsx(defaultComponents.Input, _extends({}, props, {
    css: {
      // Hide filter input blink cursor when the search icon is not visible.
      // Prevent the cursor from showing before the placeholder or after
      // the selected value.
      opacity: showCursor(props) ? 1 : 0
    }
  }));
}
function SingleValue(props) {
  var selectProps = props.selectProps,
    children = props.children;
  return jsx(defaultComponents.SingleValue, props, selectProps.menuIsOpen ? null : children);
}
function Placeholder(props) {
  return props.selectProps.menuIsOpen ? null : jsx(defaultComponents.Placeholder, props);
}
function MenuList(props) {
  var inputValue = props.selectProps.inputValue;
  var inputValueRef = React.useRef(inputValue);
  var menuListRef = React.useRef(null);

  // We want to reset the menu list scroll on filtering value change.
  // See https://phabricator.corp.gandi.net/T62724
  React.useEffect(function () {
    if (menuListRef.current instanceof HTMLElement && inputValueRef.current !== inputValue) {
      menuListRef.current.scrollTop = 0;
      inputValueRef.current = inputValue;
    }
  }, [inputValue]);
  return jsx(defaultComponents.MenuList, _extends({}, props, {
    innerRef: function innerRef(node) {
      props.innerRef(node);
      menuListRef.current = node;
    }
  }));
}
function Option(props) {
  var _props$data = props.data,
    tags = _props$data.tags,
    value = _props$data.value;
  if (Array.isArray(tags) && tags.length > 0) {
    var children = props.children,
      extraProps = _objectWithoutProperties(props, _excluded2);
    return jsx(defaultComponents.Option, _extends({}, extraProps, {
      css: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: spacings.xxsmall
      }
    }), jsx("span", {
      css: {
        marginRight: spacings.xsmall
      }
    }, children), jsx(TagList, {
      id: "taglist-".concat(value),
      tags: tags,
      max: 8
      // Prevent the "more" tag click to select the option but open the dropdown instead.
      // The `cloneElement` of `DropDownContainer` does not allow event forward for now.
      // So we bind it here.
      // This has the disadvantage, or advantage... to disable clicks on the whole tag list.
      ,
      onClick: function onClick(evt) {
        return evt.stopPropagation();
      }
    }));
  }
  return jsx(defaultComponents.Option, props);
}
var components = {
  ClearIndicator: ClearIndicator,
  IndicatorSeparator: IndicatorSeparator,
  DropdownIndicator: DropdownIndicator,
  LoadingIndicator: LoadingIndicator,
  MultiValue: MultiValue,
  SingleValue: SingleValue,
  Control: Control,
  Input: Input,
  Placeholder: Placeholder,
  MenuList: MenuList,
  Option: Option
};
export { theme, styles, components };